import { Directive, Input, OnChanges } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { ReportHeader } from "../models/report.model";

@Directive({
  selector: "[reportSort]"
})
export class ReportSortDirective implements OnChanges {
  @Input() reportSortDataSource: MatTableDataSource<any>;
  @Input() reportSortHeaders: ReportHeader[];

  ngOnChanges(): void {
    if (!this.reportSortDataSource || !this.reportSortHeaders) return;

    this.reportSortDataSource.sortingDataAccessor = (row, columnId) => {
      const cell = row[columnId];
      if (!cell) return "";

      const header = this.reportSortHeaders.find(h => h.field === columnId);
      const type = header?.type ?? "string";

      switch (type) {
        case "number":
        case "percentage":
        case "dollar":
          return typeof cell.value === "number" ? cell.value : parseFloat(cell.value) || 0;
        default:
          return (cell.value ?? "").toString().toLowerCase();
      }
    };
  }
}
